import * as Request from 'request-promise'
import { environment } from '../../environments/index.jsx'
import { CrudService  } from '../crud'

export class LicenseService extends CrudService {
    constructor(){
        super("license")
    }

}


// WEBPACK FOOTER //
// ./src/services/crud/license.js